import requests from "./httpServices";

export const startStreaming = (data) => {
  return requests.post("/agora/streaming/start", data);
};

export const stopStreaming = (data) => {
  return requests.post("/agora/streaming/stop", data);
};

export const getStreamingStatus = (channelName) => {
  return requests.get(`/agora/streaming/status/${channelName}`);
};
